<template>
  <div class="task-container">
    <!-- 列表头部栏 -->
    <r-pointer :textName="`${$t('taskData.taskDataM')} -- ${$t('taskData.view.dataView')}`">
    </r-pointer>
    <!-- 搜索模块 -->
    <r-search
      class="p_search"
      @on-blur="getCommonSearchOpt"
      @on-search="handleCommonSearch">
      <div slot="senior">
        <!-- 高级搜索条件 -->
        <a-form :form="form" @submit="handleSearch" layout="inline">
          <a-row :gutter="12">
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.procName')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'procName',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in proList" :key="index" :value="item.procCode"> {{ item.procName || item.procCode }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.robot')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'agentNo',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in robotList" :key="index" :value="item.agentNo"> {{ item.agentAlias || item.agentNo }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.taskStatus')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'status',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in taskStatusList" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="16">
              <a-form-item :label="`${$t('formAbout.taskTime')}`" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-range-picker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  v-decorator="[
                    'taskTime']"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="8" class="btn_gruop">
              <a-col span="6"></a-col>
              <a-col span="18">
                <a-button type="primary" html-type="submit" > {{ $t('formAbout.searchBtn') }} </a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="handleReset"> {{ $t('formAbout.clear') }} </a-button>
              </a-col>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <span slot="btn">
        <!-- 自定义字段 -->
        <a-tooltip
          placement="top"
          :title="`${$t('formAbout.customizeFields')}`">
          <i class="iconfont iconzidingyiziduan" @click="openModal"></i>
        </a-tooltip>
        <!-- 导出 -->
        <!-- <a-tooltip
          placement="top"
          :title="`${$t('formAbout.export')}`">
          <i class="iconfont icondaochu"></i>
        </a-tooltip> -->
      </span>
    </r-search>
    <!-- 表格列表
      :rowSelection="rowSelection" -->
    <a-table
      :dataSource="dataList"
      :pagination="pagination"
      :loading="loading"
      rowKey="id"
      :scroll="{ x: tableW }">
      <a-table-column
        v-for="(item, index) in thFieldsData"
        :dataIndex="item.fieldName"
        :key="item.fieldName"
        class="header-box"
        width="200px">
        <a-row slot="title" type="flex" justify="start" >
          <div>
            <!-- 表头显示名 -->
            <span>{{ item.displayName }}</span>
            <!-- 操作符 -->
            <span class="operation-icon">
              <!-- 删除 -->
              <a-tooltip
                placement="top"
                :title="`${$t('operation.deleteCurCol')}`">
                <i class="iconfont iconcuowu" @click="deleteCol(item.fieldName)"></i>
              </a-tooltip>
              <!-- 左移 -->
              <a-tooltip
                v-if="index!=0 && thFieldsData.length!=1"
                placement="top"
                :title="`${$t('operation.curColTurnLeft')}`">
                <i class="iconfont iconxiangzuo" @click="turnL(item.fieldName)"></i>
              </a-tooltip>
              <!-- 右移 -->
              <a-tooltip
                v-if="index!=thFieldsData.length-1 && thFieldsData.length!=1"
                placement="top"
                :title="`${$t('operation.curColTurnRight')}`">
                <i class="iconfont iconxiangyou" @click="turnR(item.fieldName)"></i>
              </a-tooltip>
            </span>
          </div>
          <a-col v-if="false" :span="16">
            {{ item.displayName }}
          </a-col>
          <a-col v-if="false" :span="4">
            <a-tooltip
              placement="top"
              :title="`${$t('operation.deleteCurCol')}`">
              <i class="iconfont iconcuowu" @click="deleteCol(item.fieldName)"></i>
            </a-tooltip>
            <a-tooltip
              v-if="index!=0 && thFieldsData.length!=1"
              placement="top"
              :title="`${$t('operation.curColTurnLeft')}`">
              <i class="iconfont iconxiangzuo" @click="turnL(item.fieldName)"></i>
            </a-tooltip>
            <a-tooltip
              v-if="index!=thFieldsData.length-1 && thFieldsData.length!=1"
              placement="top"
              :title="`${$t('operation.curColTurnRight')}`">
              <i class="iconfont iconxiangyou" @click="turnR(item.fieldName)"></i>
            </a-tooltip>
          </a-col>
        </a-row>
        <!-- 渲染 -->
        <div class="td-min-width" slot-scope="text, record">
          <template>
            <div v-if="item.fieldName != 'status' && item.fieldName.indexOf('time') == -1">
              <span v-if="item.fieldName == 'robot_no'">{{ record.agent_alias || text || '-' }}</span>
              <span v-else-if="item.fieldName == 'proc_name' || item.fieldName == 'proc_no'">{{ record.proc_name || record.proc_no || '-' }}</span>
              <span v-else>{{ text || '-' }}</span>
            </div>
            <div v-else-if="item.fieldName.indexOf('time') !== -1">
              {{ text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-' }}
            </div>
            <div v-else>
              <i :class="`iconfont icon${text} ${text}`"></i>
              {{ taskStatus[text] }}
            </div>
          </template>
        </div>
      </a-table-column>
      <!-- 内容 -->
      <a-table-column
        v-if="showContentField"
        :title="`${$t('taskData.view.content')}`"
        dataIndex="all"
        align="left"
        key="all"
        width="300px">
        <div class="td-scrolls" slot-scope="text">
          <template>
            {{ JSON.parse(text) }}
          </template>
        </div>
      </a-table-column>
      <!-- 操作 -->
      <a-table-column
        :title="$t('operation.tableOperation')"
        key="operation"
        fixed="right"
        align="right"
        width="140px">
        <div class="td-operation" slot-scope="record">
          <template>
            <a v-if="!showContentField" @click="handleViewDetails(record)">{{ $t('operation.viewDetails') }}</a>
            <br v-if="!showContentField">
            <a @click="handleViewLogs(record.item_no)">{{ $t('operation.viewLogs') }}</a>
            <br>
            <!-- 已经失败的状态下，显示重做操作 -->
            <a v-if="record.status=='failed'" @click="handleReAction(record)">{{ $t('page.task.action[1]') }}</a>
            <a-divider v-if="record.status=='failed'" type="vertical" />
            <a @click="handleDel(record.id)">{{ $t('operation.variateDel') }}</a>
          </template>
        </div>
      </a-table-column>
    </a-table>
    <!-- 自定义显示字段 Modal -->
    <a-modal
      :title="$t('taskData.view.customField')"
      v-model="mShow"
      :destroyOnClose="false"
      :footer="null"
      @cancel="handleCancel"
      width="888px">
      <!-- 保存按钮 -->
      <a-row class="save-fields" type="flex" justify="end">
        <a-button
          :loading="modalLoading"
          type="primary"
          :disabled="selectedRowNum!=0"
          @click="handleOk">{{ $t('operation.save') }}</a-button>
      </a-row>
      <!-- 所有自定义字段 -->
      <a-table
        :dataSource="allFieldsData"
        :columns="allColumns"
        :pagination="false"
        rowKey="fieldName"
        :scroll="{y: 555}">
        <!-- 选择 -->
        <span slot="choose" slot-scope="text, record">
          <template>
            <i
              :class="{iconfont: true, iconxuanze: true, 'custom-field-choose': true, active: text}"
              @click="chooseFields(record)"></i>
          </template>
        </span>
        <span slot="displayName" slot-scope="text, record">
          <template>
            <editable-cell :text="text" @change="onCellChange(record.fieldName, 'displayName', $event)"/>
          </template>
        </span>
      </a-table>
    </a-modal>
    <!-- 查看详情 Modal -->
    <content-view
      :m-show="showContent"
      @cancel="closeContent"
      :all-columns="contentCols"
      :all-fields-data="contentList"
      :json-data="contentJson"
      :copy="true"
      :boxed="true"></content-view>
  </div>
</template>

<script>
import { apiViewData } from '@/api/taskDataM'
import { apiRobot } from '@/api/robot'
import { apiProcess } from '@/api/process'
import moment from 'moment'
// import { transformRequest } from '@/utils/util'
import { modalTip, tipMsg } from '@/utils/tipTools'

export default {
  data () {
    return {
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      // 任务状态，键值对
      taskStatus: {
        pending: this.$t('taskData.status.pending'),
        waittimeout: this.$t('taskData.status.waittimeout'),
        running: this.$t('taskData.status.running'),
        succ: this.$t('taskData.status.success'),
        failed: this.$t('taskData.status.failed'),
        deleted: this.$t('taskData.status.deleted'),
        retry: this.$t('taskData.status.retry')
      },
      // 机器人列表
      robotList: [],
      // 流程列表
      proList: [],
      modalLoading: false, // 控制保存按钮的loading状态
      // 表头字段数据
      thFieldsData: [],
      showContentField: false, // 控制内容字段的显示/隐藏
      // 获取表头字段入参
      getThFieldsParams: {
        viewName: '', // 视图名
        viewModule: 'space_data', // 视图模块 space_data -- 空间数据, space_access_log -- 空间访问日志, business_log -- 业务日志
        viewParam: '', //	参数
        viewTime: '', // 视图新增时间
        viewParamId: '' // 空间Id
      },
      // 自定义字段
      allColumns: [
        {
          title: this.$t('taskData.view.fieldName'),
          dataIndex: 'fieldName',
          key: 'fieldName',
          width: 150
        },
        {
          title: this.$t('taskData.view.choose'),
          dataIndex: 'choose',
          key: 'choose',
          width: 80,
          scopedSlots: { customRender: 'choose' }
        },
        {
          title: this.$t('taskData.view.reference'),
          dataIndex: 'reference',
          key: 'reference'
        },
        {
          title: this.$t('taskData.view.displayName'),
          dataIndex: 'displayName',
          key: 'displayName',
          width: 300,
          scopedSlots: { customRender: 'displayName' }
        }
      ],
      allFieldsData: [], // 自定义字段表格数据
      // -----表格相关
      columns: [],
      // 空间子项列表查询入参
      params: {
        queueName: '', // 空间名
        queryAll: '', // 模糊搜索
        procName: '', // 流程名
        agentNo: '', // 机器人编号
        status: '', // 状态：pending:等待派发 running:正在执行 succ:执行成功 failing:失败中的 failed:已经失败 stopping:准备停止 stopped:已停止
        startTime: '', // 任务开始时间
        endTime: '' // 任务结束时间
      },
      // 列表数据
      dataList: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        showQuickJumper: true, // 可以快速跳转至某页
        onChange: this.handlePagition,
        onShowSizeChange: this.handlePageSize
      },
      loading: false,
      // 表格选择功能
      rowSelection: {
        onChange: this.onSelectChange
      },
      // 批量选择的数据
      selectedRowData: '',
      // 选中数据的条数，用来控制表格下方多选操作按钮的可操作性
      selectedRowNum: 0,
      // Modal相关
      mShow: false, // 显示/隐藏
      isChange: false, // 判断新增/修改操作
      showContent: false, // 是否查看详情
      contentCols: [ // 详情，表格列
        {
          title: this.$t('taskData.view.fieldName'),
          dataIndex: 'fieldName',
          key: 'fieldName',
          width: 200
        },
        {
          title: this.$t('taskData.view.reference'),
          dataIndex: 'reference',
          key: 'reference'
        }
      ],
      contentList: [], // 详情，表格数据
      contentJson: {} // 详情，json格式数据
    }
  },
  computed: {
    // 任务状态
    taskStatusList () {
      const statusArr = []
      Object.keys(this.taskStatus).forEach(key => {
        statusArr.push({
          label: this.taskStatus[key],
          value: key
        })
      })
      return statusArr
    },
    // 动态设置表格列的宽度
    tableW () {
      return this.thFieldsData.length <= 4 ? '100%' : (this.thFieldsData.length + 2) * 200
    }
  },
  created () {
    // console.log(this.$route.params)
    // 表头入参
    this.getThFieldsParams.viewName = this.$route.params.queueId
    this.getThFieldsParams.viewParamId = this.$route.params.queueId
    this.params.queueName = this.$route.params.queueName
    // 获取表头数据
    this._fetchThList()
    // 获取机器人列表数据
    this._fetchRobotList()
    // 获取流程名列表数据
    this._fetchProList()
  },
  // watch: {
  //   columns(newVal, oldVal) {
  //     console.log('最新的长度是：' + newVal.length)
  //   }
  // },
  methods: {
    moment,
    // 获取表头数据
    _fetchThList () {
      this.loading = true
      // 获取任务列表数据
      apiViewData.getThFields(this.getThFieldsParams).then(data => {
        // console.log(data)
        // 内容字段的显示/隐藏，默认不显示
        this.showContentField = false
        // 获取要显示的表头字段
        if (data.items[0].fields.length > 0) {
          this.thFieldsData = data.items[0].fields.filter(field => {
            // 判断筛选中，是否有all字段
            if (field.fieldName === 'all') {
              this.showContentField = true
            }
            return field.fieldName !== 'all'
          })
        } else {
          this.thFieldsData = []
          this.showContentField = true
        }
        // console.log('-----初始化表头')
        // console.log(this.thFieldsData)
        // 获取对应的列表数据
        this._fetchList()
      })
    },
    // 删除当前列
    deleteCol (colName) {
      // console.log(colName)
      let newCols = []
      if (this.thFieldsData.length > 1) {
        newCols = this.thFieldsData.filter(col => {
          return col.fieldName !== colName
        })
      } else {
        newCols = []
      }
      // console.log(newCols)
      this.setTh(this.reorganizationTh(newCols))
    },
    // 列左移
    turnL (colName) {
      this.controlThMovePos(colName, this.thFieldsData, 'left')
    },
    // 列右移
    turnR (colName) {
      this.controlThMovePos(colName, this.thFieldsData, 'right')
    },
    // 控制表头的移动
    controlThMovePos (colName, thData, direction) {
      // console.log(colName)
      // 拿到要移动的表头的索引
      const fieldIndex = this.thFieldsData.findIndex(field => field.fieldName === colName)
      // console.log(fieldIndex)
      // 将之前的表头数据保存到新的变量中
      const newThData = this.thFieldsData
      // 拿到要转移的表头数据
      const turnField = this.thFieldsData[fieldIndex]
      if (direction === 'right') {
        newThData[fieldIndex] = this.thFieldsData[fieldIndex + 1]
        newThData[fieldIndex + 1] = turnField
      } else {
        newThData[fieldIndex] = this.thFieldsData[fieldIndex - 1]
        newThData[fieldIndex - 1] = turnField
      }
      // console.log('移动后：')
      // console.log(newThData)
      this.setTh(this.reorganizationTh(newThData))
    },
    // 重组th数据
    reorganizationTh (thData) {
      console.log(thData)
      const newTh = []
      thData.forEach(th => {
        newTh.push({
          fieldName: th.fieldName,
          displayName: th.displayName,
          fieldPos: ''
        })
      })
      return newTh
    },
    // 控制表头显示
    setTh (fields) {
      apiViewData.addTh({
        viewParam: '',
        viewTime: new Date(),
        viewName: this.$route.params.queueId,
        viewModule: 'space_data',
        viewParamId: this.$route.params.queueId,
        fields
      }).then(res => {
        console.log('表头已操作' + res)
        if (this.modalLoading) {
          this.modalLoading = false
          this.mShow = false
        }
        this._fetchThList()
      })
    },
    /**
     * 高级搜索表单清空
     */
    handleReset () {
      this.form.resetFields()
      this.params.startTime = ''
      this.params.endTime = ''
    },
    /**
     * 获取任务列表数据
     */
    _fetchList () {
      this.dataList = []
      // 获取空间子项列表数据
      apiViewData.getSpaceData(this.params, this.pagination.current, this.pagination.pageSize).then(data => {
        // console.log(data)
        this.pagination.total = data.total
        // 给每条数据，新增一个 内容 字段
        data.hits.forEach(record => {
          record['all'] = JSON.stringify(record)
        })
        this.dataList = data.hits
        // 空间子项有数据时，再组装自定义字段表格数据
        if (this.dataList.length > 0) {
          this.setCustomFieldsData(JSON.parse(this.dataList[0].all))
        }
        this.loading = false
      })
    },
    // 重组自定义字段表格数据
    setCustomFieldsData (initData) {
      this.allFieldsData = []
      // 初始化的内容字段数据
      // console.log(ini/tData)
      // 已显示的表头字段数据
      // console.log(this.thFieldsData)
      Object.keys(initData).forEach(key => {
        // console.log(key)
        // 判断字段是否已被选中，根据已有的th字段，控制 '选择' 状态
        const findIndex = this.thFieldsData.findIndex(th => th.fieldName === key)
        // console.log(findIndex)
        const isSChoosed = findIndex !== -1
        // console.log(`${key} --- ${isSChoosed}`)
        this.allFieldsData.push({
          fieldName: key, // 显示字段
          choose: isSChoosed, // 选择
          reference: initData[key], // 参考值
          displayName: isSChoosed ? this.thFieldsData[findIndex].displayName : '-' // 显示名称，若为已选择，则可拿到该字段对应的显示名称，否则，默认显示 '-'
        })
      })
    },
    // 表格分页
    handlePagition (page, pageSize) {
      // console.log(page)
      this.pagination.current = page
      this._fetchList()
    },
    // 表格切换size
    handlePageSize (current, pageSize) {
      console.log(pageSize)
      this.pagination.pageSize = pageSize
      this._fetchList()
    },
    // 表格选中操作
    onSelectChange (selectedRowKeys, selectedRows) {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
      this.selectedRowData = selectedRowKeys.join(',')
      this.selectedRowNum = selectedRowKeys.length
    },
    /**
     * 失焦获取普通搜索条件值
     */
    getCommonSearchOpt (opt) {
      // alert(opt)
      this.params.queryAll = opt
    },
    // 模糊搜索
    handleCommonSearch () {
      // alert('模糊搜索')
      this.pagination.current = 1
      this._fetchList()
    },
    /**
     * 获取机器人列表数据
     */
    _fetchRobotList () {
      apiRobot.list().then(data => {
        this.robotList = data.items
      })
    },
    /**
     * 获取流程列表数据
     */
    _fetchProList () {
      apiProcess.list().then(data => {
        this.proList = data.items
      })
    },
    // 高级搜索
    handleSearch (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          // 遍历form获取到的字段，赋值给params
          Object.keys(values).forEach(key => {
            if (key === 'taskTime') {
              if (values[key]) {
                this.params.startTime = values[key][0].format('YYYY-MM-DD HH:mm:ss')
                this.params.endTime = values[key][1].format('YYYY-MM-DD HH:mm:ss')
              }
            } else {
              this.params[key] = values[key]
            }
          })
          // console.log(values)
          // console.log(this.params)
          this.pagination.current = 1
          this._fetchList()
        }
      })
    },
    // 打开自定义字段弹窗
    openModal () {
      if (this.pagination.total === 0) {
        tipMsg('warning', `${this.$t('taskData.view.customFieldMsg')}`)
        return
      }
      // 打开modal
      this.mShow = true
      this.isChange = true
      // 获取 自定义字段 列表数据
    },
    // Modal点击确定 关闭时
    // 保存自定义字段
    handleOk (e) {
      // console.log(e)
      this.modalLoading = true
      // console.log(this.allFieldsData)
      const newCusFields = []
      // 获取用户选中的自定义字段
      this.allFieldsData.forEach(field => {
        if (field.choose) {
          newCusFields.push({
            fieldName: field.fieldName,
            displayName: field.displayName !== '-' ? field.displayName : field.fieldName,
            fieldPos: ''
          })
        }
      })
      // console.log(newCusFields)
      // 自定义字段
      this.setTh(newCusFields)
      // this.isChange ? this.realMod(values) : this.realAdd(values)
    },
    // Modal点击遮罩层或右上角叉或取消按钮的回调 关闭时
    handleCancel (e) {
      // console.log(e)
      // 关闭弹窗
      this.mShow = false
    },
    // 自定义字段选中
    chooseFields (record) {
      // console.log(record)
      record.choose = !record.choose
    },
    // 单元格编辑
    onCellChange (fieldName, dataIndex, value) {
      const dataSource = [...this.allFieldsData]
      const target = dataSource.find(item => item.fieldName === fieldName)
      if (target) {
        target[dataIndex] = value
        this.allFieldsData = dataSource
      }
    },
    // 查看详情
    handleViewDetails (row) {
      // console.log(row)
      this.showContent = true
      // 初始数据
      const initData = JSON.parse(row.all)
      this.contentJson = initData
      // console.log(initData)
      // 初始化列表数据
      this.contentList = []
      // 组装详情表格列表数据
      Object.keys(initData).forEach(key => {
        this.contentList.push({
          fieldName: key, // 显示字段
          reference: initData[key] // 参考值
        })
      })
    },
    // 关闭详情
    closeContent () {
      this.showContent = false
    },
    // 删除
    handleDel (rowID) {
      // console.log(rowID)
      this.realDel(rowID)
    },
    // 删除，可批量删除
    realDel (delItem) {
      modalTip(
        'confirm',
        `${this.$t('taskData.view.delTipMsg')}`,
        () => {
          apiViewData.del(delItem).then(data => {
            tipMsg('success', `${this.$t('msg.delSuceess')}`)
            // 清空之前选中的数据
            // this.cleanSelectd()
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 重做
    handleReAction (row) {
      // console.log(row)
      modalTip(
        'confirm',
        `${this.$t('taskData.view.restartTipMsg')}`,
        () => {
          apiViewData.reStart({
            id: row.id
          }).then(data => {
            tipMsg('success', `${this.$t('task.readyToReDo')}`)
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 清空之前选中的数据
    cleanSelectd () {
      // console.log(this.selectedRowData)
      this.selectedRowData = ''
      this.selectedRowNum = 0
    },
    // 查看日志
    handleViewLogs (itemNo) {
      // alert('开发中...')
      this.$router.push(`/taskViewLogs/${this.$route.params.queueName}/${itemNo}`)
    }
  }
}
</script>

<style lang="less" scoped>
  .task-container {
    background-color: #fff;
    padding: 0 24px 12px;
    position: relative;
  }
  // 自定义字段Modal
  .save-fields {
    margin-top: -14px!important;
    margin-bottom: 10px;
  }
  // 日期时间选择器
  /deep/.ant-calendar-picker {
    width: 100%!important;
  }
  // 高级搜索的按钮
  .btn_gruop {
    margin: 10px -5px;
  }
  // 表头单元格操作，删除、左移、右移
  .header-box {
    .operation-icon {
      visibility: hidden;
      padding-left: 8px;
      position: relative;
      top: 2px;
      i {
        cursor: pointer;
        margin-left: 3px;
        &:hover {
          color: #4977FC;
        }
        &:first-of-type:hover {
          color: red;
          font-weight: bold;
        }
      }
    }
    &:hover {
      .operation-icon {
        visibility: visible;
      }
    }
  }
  .td-min-width {
    min-width: 150px!important;
  }
  // 内容单元格
  .td-scrolls {
    max-height: 150px;
    overflow-y: auto;
  }
  .td-operation {
    min-width: 140px;
  }
  /deep/.ant-table-header,
  /deep/.ant-table-body {
    overflow-y: auto!important;
  }
  // 表单
  .ant-row {
    margin-top: 5px;
    width: 100%;
    /deep/.ant-form-item-label {
      text-align: left;
      // width: 100px;
    }
  }
  // 表格
  .ant-table-wrapper {
    padding-top: 10px;
  }
  // 自定义字段表格，选择字段，字体样式
  .custom-field-choose {
    color: #CCC;
    cursor: pointer;
    &.active,
    &:hover {
      color: #4977FC;
    }
  }
  // 状态 icon 图标颜色
  .pending {
    color: #83D5FF;
  }
  .running {
    color: #4977FC;
  }
  .succ {
    color: #52C41A;
  }
  .failing {
    color: #FFB75F;
  }
  .failed {
    color: #333333;
  }
  .stopping {
    color: #EC6941;
  }
  .stopped {
    color: #F5222D;
  }
</style>
